export const supportedLocales = ['en', 'ja'];
